import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpService } from '../http.service';

const HEADERS = {};
@Injectable()
export class ReceptionAdvancedService {

  static ENV = environment;

  constructor(
    private httpService: HttpService,
  ) { }

  public getSuppliers(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(ReceptionAdvancedService.ENV.environment.API.get_suppliers, httpRequesthandler);
  }

  public getOrdenInvoice(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(ReceptionAdvancedService.ENV.environment.API.get_orderinvoice, httpRequesthandler);
  }

  public getInvoicesReport(data, http_handdler: HttpRequestHandler) {
    http_handdler.headers = HEADERS;
    this.httpService.post(ReceptionAdvancedService.ENV.environment.API.report_invoices, data, http_handdler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/reception-advanced/reception-advanced.service.ts